package top.wcpe.allincore.ui.runtime.ir.api

import top.wcpe.allincore.ui.runtime.internal.concurrent.AtomicRef
import kotlin.jvm.JvmStatic

/** 全局共享的 PersistApi 实例 holder（SPI Holder 三件套）。 */
class PersistApiHolder private constructor() {
    companion object {
        private val INSTANCE: AtomicRef<PersistApi> = AtomicRef(PersistApi.NOOP)

        @JvmStatic fun set(api: PersistApi?) {
            INSTANCE.set(api ?: PersistApi.NOOP)
        }

        @JvmStatic fun setInstance(api: PersistApi?) = set(api)

        @JvmStatic fun get(): PersistApi = INSTANCE.get()

        @JvmStatic fun clear() {
            INSTANCE.set(PersistApi.NOOP)
        }
    }
}
